import { ReactElement } from 'react';

import { PatientPresence } from '@dreryk/egabinet-visit-frontend-api';

import { IconFillColor, IconSize, IconWrapper, NonWaitingIcon, WaitingIcon } from '@dreryk/react-components';

type AppointmentsTimetableEventPatientPresenceStatusIconProps = {
   patientPresence: PatientPresence;
};

export const AppointmentsTimetableEventPatientPresenceStatusIcon = (
   props: AppointmentsTimetableEventPatientPresenceStatusIconProps
): ReactElement => {
   const patientPresent = props.patientPresence === 'PRESENT';
   return (
      <IconWrapper
         testId={'patientPresenceStatus'}
         fillColor={patientPresent ? IconFillColor.SUCCESS : IconFillColor.BACKGROUND}
         size={IconSize.SMALLEST}
      >
         {patientPresent ? <WaitingIcon /> : <NonWaitingIcon />}
      </IconWrapper>
   );
};
